export default __webpack_public_path__ + "static/media/3.df8ba590.jpg";